import {Select} from 'antd';
import {SelectProps} from 'antd/lib/select';
import {filterOption, getPopupContainer} from '../../../Utils/common';

export interface SelectDictProps extends Omit<SelectProps, 'children'> {}

export default function SelectDict({...props}: SelectDictProps) {
    return <Select {...props} />;
}

SelectDict.defaultProps = {
    filterOption, // 默认改为按标签搜索
    getPopupContainer, // 默认在跟随容器滚动
    placeholder: '请选择', // 默认提示文字
    allowClear: true,
    showSearch: true,
};
